<script setup>

const { locale } = useI18n()
const url = useRequestURL()
const route = useRoute()
const sizerCookie = useCookie('sizerCookie')

const { data: pageInit } = await useAPIFetch('Catalogue')
const list = pageInit.value.body.find(item => item.component === 'List')
const componentId = ref(list.id)
const isLoading = ref(false)
const limit = ref(list.params.limit || sizerCookie.value * 3 || 12)
const sortValue = ref(null)
const startsWith = ref(null)
const filterValue = ref(null)
let filterQuery = null

if(Object.keys(route.query).length !== 0) {
	let filterParts = []

	for (const [key, value] of Object.entries(route.query)) {
		filterParts.push(`${key}:${value}`)
	}
	filterQuery = [filterParts.join('|')]
}

let params = {}
if (filterQuery) params.filter = filterQuery

const { data: page } = await useAPIFetch(`Catalogue/component/${componentId.value}`, {
	query: {
		'limit': limit.value,
		...params
	}
})

const cursor = ref(page.value.cursor)
let items = ref(page.value.items)

const updateSort = (value, selectedFilter) => {
	startsWith.value = null
	sortValue.value = value
	updateFilter(selectedFilter)
}

const setStartsWith = (value) => {
	startsWith.value = value
	updateFilter(null, true)
}

const updateFilter = (value, settingStartsWith = false) => {
	let filterParts = []
	if (!settingStartsWith) {
		if(value) {
			value.forEach(item => {
				filterParts.push(`${item.parameter}:${item.value.key}`)
			});
		}

		if(startsWith.value) {
			filterParts.push(`title~${startsWith.value}`)
		} else {
			filterParts = filterParts.filter(item => !item.includes('title~'))
		}

		filterValue.value = filterParts.join('|')
	} else {

		let filterParts = filterValue.value.split('|')
		filterParts = filterParts.filter(item => !item.includes('title~'))

		filterValue.value = filterParts.join('|')

		filterValue.value += `|title~${startsWith.value}`
	}

	updateList()
}

const resetFilter = () => {
	filterValue.value = null
	startsWith.value = null
	updateList()
}

const loadMore = async () => {
	updateList(true)
}

const updateList = async (loadMore = false) => {
	isLoading.value = true

	let params = {}
	if (sortValue.value) params.orderBy = sortValue.value
	if (filterValue.value) params.filter = filterValue.value

	const result = await useUIFetch(locale.value, `Catalogue/component/${componentId.value}`, {
		'cursor': loadMore ? cursor.value : null,
		'limit': limit.value,
		...params
	})
	if (loadMore) {
		items.value = [...items.value, ...result.items]
	} else {
		items.value = [...result.items]
	}
	cursor.value = result.cursor
	isLoading.value = false
}

const changeLimit = (value) => {
	limit.value = parseInt(value)
	updateList()
}

watch(() => route.query, () => {
  if(!Object.entries(route.query)?.length) {
		resetFilter()
	}
});

useHead({
	bodyAttrs: {
		class: 'has-sizer'
	}
})

useHeadData({
  title: pageInit.value.meta.title,
  description: pageInit.value.meta.description,
	author: pageInit.value.meta.author,
	copyright: pageInit.value.meta.copyright,
	keywords: pageInit.value.meta.keywords,
	og: pageInit.value.meta.og,
	url: url.href
})

</script>

<template>
	<div>
		<div class="container">
			<div class="md:flex justify-between">
				<h1 class="text-lilac mb-4 md:mb-0">{{ pageInit.attrs.title }}</h1>
				<Filter @update:sort="updateSort" @update:filter="updateFilter" @reset:filter="resetFilter" color="lilac" :defaultOrder="list.params.orderBy" :orderOptions="list.orderBy || []" :filterProperties="list.filter ? list.filterProperties : null" />
			</div>
			<FilterGeneralAlphabet @starts-with="setStartsWith" :isActive="sortValue === 'title'" />
		</div>
		<Grid @loadMore="loadMore" @changeLimit="changeLimit" :covers="items" :cursor="cursor?.toString()" :loading="isLoading" />
	</div>
</template>